// Shared phone formatter for the TFS ecosystem.
// Valid 10-digit U.S. numbers display as (305) 555-1212; 11-digit numbers with a
// leading 1 are treated as U.S.; international numbers (+XX...) are preserved
// untouched. Anything else is returned exactly as entered — never corrupted.
export function formatPhone(value) {
  if (!value) return value;
  const raw = String(value).trim();
  if (raw.startsWith("+") && !raw.startsWith("+1")) return raw; // international — preserve
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits.startsWith("1")) {
    const d = digits.slice(1);
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }
  return raw; // not a recognizable U.S. number — leave as entered
}

// onBlur handler factory for controlled inputs: formats the field in state so the
// formatted value is what gets saved. Typing is never disrupted mid-entry.
export function phoneBlur(setter) {
  return (e) => {
    const formatted = formatPhone(e.target.value);
    if (formatted !== e.target.value) setter(formatted);
  };
}
